type Fbq = (...args: any[]) => void;

type FbqInternal = Fbq & {
  callMethod?: (...args: any[]) => void;
  queue?: any[];
  loaded?: boolean;
  version?: string;
  push?: (...args: any[]) => void;
};

export const QQ_META_PIXEL_ID = '764708837412432';

const QQ_GA_MEASUREMENT_ID = 'G-KM9EQDBMQH';

let pixelBootstrapped = false;
let pixelInited = false;

/**
 * Loads Meta Pixel base snippet and calls `init` for the QQ pixel.
 * IMPORTANT: This is intended to be used ONLY on `/qq/*`.
 */
export function ensureQQPixelLoaded(pixelId: string = QQ_META_PIXEL_ID) {
  if (typeof window === 'undefined') return;
  const w = window as any;

  // Ensure the base pixel snippet is present (creates a stub `fbq` that queues calls).
  if (!pixelBootstrapped && !w.fbq) {
    // eslint-disable-next-line func-names
    (function (
      f: any,
      b: Document,
      e: string,
      v: string,
      n?: FbqInternal,
      t?: HTMLScriptElement,
      s?: Element,
    ) {
      if (f.fbq) return;
      n = function () {
        // eslint-disable-next-line prefer-rest-params
        (n as any).callMethod
          ? (n as any).callMethod.apply(n, arguments)
          : (n as any).queue.push(arguments);
      } as any;
      f._fbq = n;
      f.fbq = n;
      (n as any).push = n;
      (n as any).loaded = true;
      (n as any).version = '2.0';
      (n as any).queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode!.insertBefore(t, s);
    })(w, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  }

  // Call init once for this pixel.
  if (!pixelInited) {
    w.fbq?.('init', pixelId);
    pixelInited = true;
  }

  pixelBootstrapped = true;
}

function qqTrack(eventName: string, params?: Record<string, any>) {
  ensureQQPixelLoaded();
  const fbq = (window as any).fbq as Fbq | undefined;
  if (typeof fbq !== 'function') return;

  // Avoid passing an explicit `undefined` as the params argument.
  if (params && Object.keys(params).length > 0) {
    fbq('track', eventName, params);
  } else {
    fbq('track', eventName);
  }

  // Fire GA4 generate_lead at the same moment as the Meta Pixel Lead.
  if (eventName === 'Lead') {
    // Keep this resilient if GA hasn't loaded yet by stubbing gtag (queues via dataLayer).
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer!.push(arguments);
      };

    // Ensure this measurement ID is configured; prevent implicit page_view from config.
    window.gtag?.('config', QQ_GA_MEASUREMENT_ID, { send_page_view: false });
    window.gtag?.('event', 'generate_lead', {
      send_to: QQ_GA_MEASUREMENT_ID,
    });
  }
}

export function trackQQPageView() {
  qqTrack('PageView');
}

export function trackQQLead(params?: Record<string, any>) {
  qqTrack('Lead', params);
}
